export default class PortalHelper {
  static constructOrderItemFromSubData(subData) {
    let output = JSON.parse(JSON.stringify(subData.orderItem));
    // TODO handle coupon
    // output.coupon = subData.recurringEstimate.discounts.filter
    return output;
  }

  static cloneAddons(addons) {
    return JSON.parse(JSON.stringify(addons));
  }

  static getDetailsFromCart(cart) {
    return {
      planDetail: cart.orderItems[0].plan.details,
      addonDetails: cart.orderItems[0].addons.map(({details}) => details)
    }
  }

  static displayPeriod(days, trial_unit) {
    return `${days} day${days > 1 ? 's' : ''}`;
  }

  static enableChangeSub(changedOrderItem, oldOrderItem) {
    var oldItems = [].concat(oldOrderItem.plan, oldOrderItem.addons);
    if(changedOrderItem.addons.length != oldOrderItem.addons.length) {
      return true;
    }

    return oldItems.filter(item => {
      if(item.type == "plan") {
        return (item.id != changedOrderItem.plan.id) || ((item.quantity || 1) != (changedOrderItem.plan.quantity || 1));
      }
      if(item.type == "addon") {
        let t = changedOrderItem.addons.filter(i => i.id == item.id)[0];
        return !(t && t.quantity == item.quantity);
      }
    }).length > 0 || (changedOrderItem.coupon != oldOrderItem.coupon);
  }

  static filterAddonsBasedOnPlanTerm(addons, period, periodUnit) {
    var selected_addons = []
    switch(periodUnit) {
      case "week":
        selected_addons = addons.filter(a => a.period_unit == "week" && (period % a.period) == 0);
        selected_addons = selected_addons.concat(addons.filter(a => a.period_unit == "day" && ((period * 7) % a.period) == 0))
        break;
      case "month":
        selected_addons = addons.filter(a => a.period_unit == "month" && (period % a.period) == 0);
        break;
      case "year":
        selected_addons = addons.filter(a => a.period_unit == "year" && (period % a.period) == 0);
        selected_addons = selected_addons.concat(addons.filter(a => a.period_unit == "month" && ((period * 12) % a.period) == 0))
        break;
      case "day":
        selected_addons = addons.filter(a => a.period_unit == "day" && (period % a.period) == 0);
        break;
    }

    return selected_addons;
  }

  static constructOrderItemForOtherProducts(other_product, subData) {
    var current_addons = this.cloneAddons(subData.orderItem.addons);
    var orderItem = {
      plan: {
        id: other_product.plan_id,
        quantity: other_product.plan_id == subData.orderItem.plan.id ? subData.orderItem.plan.quantity : 1,
        type: "plan"
      }
    }

    orderItem.plan.initialQuantity = orderItem.plan.quantity;

    if(other_product.plan_id == subData.orderItem.plan.id)  {
      orderItem.addons = [].concat(current_addons);
    } else {
      var selected_addons = [];
      switch(subData.retain_addons_for_change && !other_product.is_addons_restricted && other_product.period_unit) {
        case "week":
          var selected_addons = current_addons.filter(a => a.details.period_unit == "week" && (other_product.period % a.details.period) == 0);
          break;
        case "month":
          var selected_addons = current_addons.filter(a => a.details.period_unit == "month" && (other_product.period % a.details.period) == 0);
          break;
        case "year":
          var selected_addons = current_addons.filter(a => a.details.period_unit == "year" && (other_product.period % a.details.period) == 0);
          selected_addons = selected_addons.concat(current_addons.filter(a => a.details.period_unit == "month" && ((other_product.period * 12) % a.details.period) == 0))
          break;
      }

      // union of other_product.addons and selected_addons
      let o = [].concat(selected_addons);
      let tmp = selected_addons.map(({id}) => id);
      other_product.addons.forEach(a => {
        if(a.id && tmp.indexOf(a.id) == -1) {
          o.push(a);
        }
      });
      orderItem.addons = o;
    }

    orderItem.addons.forEach(addon => {
      addon.type = "addon";
      addon.quantity = addon.quantity || 1;
      addon.initialQuantity = addon.quantity;
    });
    // orderItem.coupon = hostedPage.coupon;
    // orderItem.flattened = [].concat(orderItem.plan, orderItem.addons);
    return orderItem;
  }

  static canShowBreakup(estimate) {
    return estimate && (this.hasPricingModelItem(estimate)
                || (estimate.taxes && estimate.taxes.length > 0)
                || (estimate.discounts && estimate.discounts.length > 0));
  }

  static hasPricingModelItem(estimate) {
    if(estimate.line_items && estimate.line_items.length > 0){
      return estimate.line_items.some(i => {
        switch(i.entity_type) {
          case "plan":
          case "addon":
          return i.pricing_model == "tiered";
        }
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/portal-helper.js